// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TZrga{padding:24px 16px;margin:24px -16px;background:#fff}@media screen and (min-width:768px){.TZrga{padding:16px;border:1px solid #e2e2e2;margin:32px 0;border-radius:8px}}@media screen and (min-width:1552px){.TZrga{margin:40px 0}}.TZrga.l89NU{padding-top:16px}@media screen and (min-width:768px){.TZrga.l89NU{display:flex;flex-flow:row-reverse;grid-gap:16px;gap:16px}}.D8q-Z{width:80px;height:80px;margin:0 0 20px}@media screen and (min-width:768px){.D8q-Z{flex:0 0 80px;margin:0}}@media screen and (min-width:768px){.l89NU .ulh\\+y{flex:1 1 auto}}.TqcYf{margin:0 0 8px;color:#2d2d2d;font-family:\"Merriweather\",serif;font-size:22px;font-weight:700;line-height:28px}.xhGXZ{margin:0 0 24px;color:#787878;font-size:16px;font-weight:400;line-height:22px}.TZrga ._25dq0.zxqe8{transition:filter .2s}.TZrga ._25dq0.zxqe8:active{-webkit-tap-highlight-color:rgba(0,0,0,0);filter:brightness(1.1)}@media(any-hover:hover){.TZrga ._25dq0.zxqe8:hover{filter:brightness(1.1)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "TZrga",
	"withSvg": "l89NU",
	"svg": "D8q-Z",
	"main": "ulh+y",
	"title": "TqcYf",
	"subtitle": "xhGXZ",
	"button": "_25dq0",
	"isCustomButton": "zxqe8"
};
module.exports = ___CSS_LOADER_EXPORT___;
